import { render, staticRenderFns } from "./LearnerHome.vue?vue&type=template&id=35fd21f0"
import script from "./LearnerHome.vue?vue&type=script&lang=js"
export * from "./LearnerHome.vue?vue&type=script&lang=js"
import style0 from "./LearnerHome.vue?vue&type=style&index=0&id=35fd21f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports